import React, { useState, useEffect } from "react";
import CustomTitle from "../../components/UI/title/CustomTitle";
import MyButton from "../../components/UI/button/MyButton";
import "./style.scss";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { setIsShowPrivacy } from "../../store/termSlice";
import { useCheckSubscriptionQuery, useCreateBusinessProfileMutation, useCreateFunnelMutation, useFetchBusinessProfilesQuery, useRegisterMutation, useSearchBusinessProfilesQuery, useUpdateUsersMutation } from "../../api/dataApi";
import CryptoJS from 'crypto-js';
import useFaceBook from "../../hooks/useFaceBook";
import PageContent from "../../components/PageContent/PageContent";
import axios from 'axios';
import useMixpanel from "../../hooks/useMixpanel";
import { use } from "react";

const Email = ({ save }) => {
  const history = useHistory();
  const [createFunnel, { isLoading: isCreateFunnelLoading, error: createFunnelError }] = useCreateFunnelMutation();

  const { brandName } = useSelector((state) => state.scrapping);
  const dispatch = useDispatch();
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const { sendFb } = useFaceBook();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [name, setName] = useState(save ? brandName : "");
  const { trackP1Event } = useMixpanel();

  const handleInputChange = (event) => {
    const newValue = event.target.value.replace(/\s+/g, "");
    setName(newValue);
    setError("");
  };

  useEffect(() => {
    sendFb("ViewContent", {});
  }, [])


  useEffect(() => {
    if (name == "") {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [name]);

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;

  const [error, setError] = useState("");


  const privacyChange = () => {
    dispatch(setIsShowPrivacy(true));
  };

  const [register, { isLoading, isError, isSuccess, errorRegister }] = useRegisterMutation();

  const { data: subscriptionData, error: subscriptionError, isLoading: isSubscriptionLoading } = useCheckSubscriptionQuery(name);
  const [updateUsers, { isLoading: isUpdatingUserEmail, error: updateUsersError }] = useUpdateUsersMutation();



  // const { data: subscriptionsData, error: subscriptionsError, isLoading: isSubscriptions } = useSubscriptionsCheckQuery(name)

  const secretKey = 'j5wbjG3jNJMCSI9';

  const encryptText = (text) => {
    const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString();
    return ciphertext;
  };

  const decryptText = (ciphertext) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    const original = bytes.toString(CryptoJS.enc.Utf8);
    return original;
  };

  const [loading, setLoading] = useState(false);

  const [emailSearch, setEmailSearch] = useState();

  const [shouldFetch, setShouldFetch] = useState(false);
  const { data: businessProfilesSearch, isLoading: isLoadingBusinessProfiles } = useSearchBusinessProfilesQuery(name, {
    skip: !shouldFetch,
  });

  const [createBusinessProfile, { isLoading: isCreateProfileLoading, error: createProfileError }] = useCreateBusinessProfileMutation();
  const [encryptedCode, setEncryptedCode] = useState();

  async function hashData(data) {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data?.toString().trim()?.toLowerCase() || '');
    const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
      return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
  }

  const decryptName = decryptText(queryParams.get('un') || "") || "";

  async function sendPixel() {
    const hashedName = await hashData(decryptName);
    const hashedEmail = await hashData(name);
    sendFb("Lead", {email: name}, { user_data: { fn: hashedName, em: hashedEmail } });
  }


  useEffect(() => {
    if (!isLoadingBusinessProfiles && businessProfilesSearch && shouldFetch) {
      queryParams.set('code', encryptedCode);
      queryParams.set('ue', encryptText(name));
      queryParams.set('new-account', 1);
      sendPixel()
      // sendFb("Lead", {});
      sendData()
      trackP1Event('onboarding_email', {})
      history.push({
        pathname: '/name',
        search: `?${queryParams.toString()}`,
      });
    }
  }, [businessProfilesSearch, isLoadingBusinessProfiles, shouldFetch, name])



  const handleCreateProfile = async () => {
    const data = {
      direction: queryParams.get("direction")
        ? queryParams.get("direction")
        : "PRODUCT",
      ...queryParams.get("productsType") && { productsType: queryParams.get("productsType") },
      ...queryParams.get("stage") && { businessStage: queryParams.get("stage") },
      ...decryptName && { userName: decryptName },
      ...name && { email: name },
      ...queryParams.get("ad-channels-value") && { sellChannels: queryParams.get("ad-channels-value") },
      ...queryParams.get("goals-text") && { goal: queryParams.get("goals-text") },
      ...queryParams.get("platforms-value") && {
        sitePlatform: queryParams.get("platforms-value").replace(/\.svg/g, '')
          .replace(/^./, (char) => char.toUpperCase())
      },
      ...queryParams.get("current") && { ordersPerMonth: queryParams.get("current") },
      ...queryParams.get("target") && { ordersGoal: queryParams.get("target") },
      ...queryParams.get("period") && { ordersGoalPeriod: queryParams.get("period")?.toLowerCase() },
      data: {
        videoAds: queryParams.get("video-ads") ? true : false,
        videoAvatars: queryParams.get("video-avatars") ? true : false,
        videoTemplates: queryParams.get("video-templates") ? true : false,
        videoScripts: queryParams.get("video-scripts") ? true : false,
        videoHooks: queryParams.get("video-hooks") ? true : false,
        videoConversion: queryParams.get("video-conversion") ? true : false,
        staticAds: queryParams.get("static-ads") ? true : false,
        staticTemplates: queryParams.get("static-templates") ? true : false,
        staticExamples: queryParams.get("static-examples") ? true : false,
        staticText: queryParams.get("static-text") ? true : false,
        staticEditor: queryParams.get("static-editor") ? true : false,
        staticBulk: queryParams.get("static-bulk") ? true : false,
        adCampaigns: queryParams.get("ad-campaigns") ? true : false,
        adChannels: queryParams.get("ad-channels") ? true : false,
        adTargeting: queryParams.get("ad-targeting") ? true : false,
        adOptimization: queryParams.get("ad-optimization") ? true : false,
        adReports: queryParams.get("ad-reports") ? true : false,
        adCopilot: queryParams.get("ad-copilot") ? true : false,
        adPlatform: queryParams.get("platforms-value") ? true : false,
        ...queryParams.get("productivity-goals-id") && { productivityGoalsId: queryParams.get("productivity-goals-id") },
        ...queryParams.get("target-id") && { targetId: queryParams.get("target-id") },
        ...queryParams.get("goals") && { goalsId: queryParams.get("goals") },
      }
    };

    try {
      await createBusinessProfile(data).unwrap();
      setShouldFetch(true);
      // console.log('Профиль успешно создан');
    } catch (err) {
      setLoading(false);
      console.error("Ошибка создания профиля:", err);
    }
  };


  const handleRegister = async () => {
    try {
      const response = await register(name).unwrap();
      console.log('Registration successful:', response);


      const encrypted = await encryptText(response.code, secretKey);
      localStorage.setItem('accessToken', response.data.accessToken);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      localStorage.setItem('authToken', response.data.authToken);

      setEncryptedCode(encrypted)
      if (decryptName) {
        const changeName = await updateUsers({
          name: decryptName,
        });
      }
      await handleCreateProfile();
      await businessProfilesSearch()
    } catch (err) {

      if (err.data && err.data.message === "User already exist") {
        const dataSubscription = await subscriptionData;
        setEmailSearch(name);

        queryParams.set('ue', encryptText(name));
        const hashedName = await hashData(decryptName);
        const hashedEmail = await hashData(name);
        sendFb("Lead", {email: name}, { user_data: { fn: hashedName, em: hashedEmail } });
        sendData()
        trackP1Event('onboarding_email', {})
        history.push({
          pathname: dataSubscription?.data?.status === "ACTIVE" ? '/welcome' : '/name',
          search: `?${queryParams.toString()}`,
        });
      }
      console.error('Registration failed:', err);
    }
  };


  const sendData = async () => {
    const formdata = new FormData();
    formdata.append("domen", window.location.hostname);
    formdata.append("email", name);
    formdata.append("utmSource", localStorage.getItem("utmSource"));
    formdata.append("utmMedium", localStorage.getItem("utmMedium"));
    formdata.append("utmCampaign", localStorage.getItem("utmCampaign"));
    formdata.append("utmContent", localStorage.getItem("utmContent"));
    formdata.append("utmTerm", localStorage.getItem("utmTerm"));
    try {
      const response = await axios.post("https://zee.sale/send-1-ai.php", formdata, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="emailPage">
      <div className="page">
        <PageContent>
          <div className="page-content">
            <CustomTitle
              style={{ marginBottom: "24rem" }}
              title={`${decryptName ? decryptName?.charAt(0).toUpperCase() + decryptName?.slice(1) + ', enter your email to get access to your personal AI marketing copilot' : 'Enter your email to get access to your personal AI marketing copilot'}`}
            />
            <div
              className={`input ${error ? "error" : ""}`}
              style={{ paddingLeft: "46rem", paddingRight: "16rem" }}
            >
              <input
                type="text"
                placeholder="Email"
                value={name}
                onChange={handleInputChange}
                autocapitalize="none"
              />
              <div className={`input-border ${name === '' ? 'empty' : ''}`}></div>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.80569 2.85718L14.412 2.85845C15.5369 2.87209 16.1238 2.99766 16.7325 3.32321C17.3226 3.6388 17.7899 4.10617 18.1055 4.69626C18.4514 5.34303 18.5716 5.96516 18.5716 7.23416V12.7659C18.5716 14.0349 18.4514 14.657 18.1055 15.3038C17.7899 15.8939 17.3226 16.3613 16.7325 16.6769C16.0857 17.0228 15.4636 17.1429 14.1946 17.1429H5.80569C4.53669 17.1429 3.91456 17.0228 3.26779 16.6769C2.6777 16.3613 2.21033 15.8939 1.89475 15.3038C1.54885 14.657 1.42871 14.0349 1.42871 12.7659L1.42998 7.01679C1.44363 5.89188 1.5692 5.30499 1.89475 4.69626C2.21033 4.10617 2.6777 3.6388 3.26779 3.32321C3.91456 2.97732 4.53669 2.85718 5.80569 2.85718ZM16.9195 5.52005L12.0204 10.4185C10.9419 11.497 9.21545 11.533 8.09367 10.5263L7.97983 10.4185L3.08073 5.52005C2.91686 5.88774 2.85728 6.30832 2.85728 7.23416V12.7659C2.85728 13.8192 2.9344 14.2186 3.15448 14.6301C3.33692 14.9712 3.60037 15.2347 3.9415 15.4171C4.30461 15.6113 4.65823 15.6942 5.46 15.711L5.80569 15.7143H14.1946C15.2479 15.7143 15.6473 15.6372 16.0588 15.4171C16.3999 15.2347 16.6634 14.9712 16.8458 14.6301C17.04 14.267 17.1229 13.9134 17.1397 13.1116L17.143 12.7659V7.23416C17.143 6.30832 17.0834 5.88774 16.9195 5.52005ZM14.1946 4.28575H5.80569C4.87985 4.28575 4.45928 4.34533 4.09158 4.5092L8.98999 9.4083C9.51852 9.93683 10.3581 9.96465 10.9194 9.49175L11.0103 9.4083L15.9087 4.5092C15.541 4.34533 15.1204 4.28575 14.1946 4.28575Z" fill="#CAD4DD" />
              </svg>
              <span style={{ left: "46rem" }}>Email</span>
              {error && <div className="error-text" style={{ marginLeft: '-46rem' }}>{error}</div>}
            </div>
          </div>
        </PageContent>
      </div>


      <div className="emailPage-bottom">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.7688 9.21387H16.2312C18.5886 9.21387 20.5 11.0831 20.5 13.3885V18.3254C20.5 20.6308 18.5886 22.5 16.2312 22.5H7.7688C5.41136 22.5 3.5 20.6308 3.5 18.3254V13.3885C3.5 11.0831 5.41136 9.21387 7.7688 9.21387ZM11.9949 17.8295C12.4928 17.8295 12.8891 17.4419 12.8891 16.955V14.7489C12.8891 14.272 12.4928 13.8844 11.9949 13.8844C11.5072 13.8844 11.1109 14.272 11.1109 14.7489V16.955C11.1109 17.4419 11.5072 17.8295 11.9949 17.8295Z" fill="#CAD4DD" />
          <path d="M17.5227 7.89595V9.36667C17.1671 9.2673 16.7911 9.21761 16.405 9.21761H15.7445V7.89595C15.7445 5.87868 14.0679 4.23903 12.0051 4.23903C9.94233 4.23903 8.2657 5.86874 8.25554 7.87608V9.21761H7.60521C7.20891 9.21761 6.83294 9.2673 6.47729 9.37661V7.89595C6.48746 4.91476 8.95667 2.5 11.9848 2.5C15.0535 2.5 17.5227 4.91476 17.5227 7.89595Z" fill="#CAD4DD" />
        </svg>

        <p>
          We respect your privacy and protect your personal data. It’s processed securely under our  <span onClick={privacyChange}>Privacy Policy.</span>

        </p>
      </div>
      <MyButton
        onClick={() => {
          if (isButtonDisabled) {
            setError("Enter your email to continue");
            return;
          }
          if (!emailRegex.test(name)) {
            setError("That email doesn't look right. Please correct it.");
            return;
          }
          setLoading(true);
          createFunnel({ pageId: 'v2' });
          handleRegister()
        }}
        className={`

         ${error ? 'error' : ''}`}
        buttonIcon={""}
        buttonText={`Continue`}
        buttonStatus={loading ? "load" : ""}
      ></MyButton>
    </div>
  );
};

export default Email;
